module.exports = __webpack_public_path__ + "static/media/data-browser.eec2f8f9.svg";